import { Clapperboard } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";

const TYPES = [
  { v: "none", label: "Nothing" },
  { v: "card", label: "End card" },
  { v: "credits", label: "Credit roll" },
];

export function ClipEnding({ ending, setEnding }) {
  const set = (patch) => setEnding({ ...ending, ...patch });
  return (
    <div className="space-y-3" data-testid="clip-ending">
      <p className="text-sm font-semibold text-white flex items-center gap-2"><Clapperboard className="h-4 w-4 text-amber-400" /> After the outro</p>
      <div className="flex gap-2">
        {TYPES.map((t) => (
          <button key={t.v} type="button" data-testid={`clip-ending-${t.v}`} onClick={() => set({ type: t.v })}
            className={"px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors " + (ending.type === t.v ? "border-amber-500 bg-amber-500/10 text-amber-300" : "border-gray-800 text-gray-400 hover:text-white")}>
            {t.label}
          </button>
        ))}
      </div>
      {ending.type !== "none" && (
        <>
          <div className="space-y-2">
            <Label className="text-gray-300 text-xs">On screen for <span data-testid="clip-ending-duration" className="text-white font-mono">{ending.duration}s</span></Label>
            <Slider data-testid="clip-ending-slider" min={5} max={20} step={1} value={[ending.duration]} onValueChange={([v]) => set({ duration: v })} />
          </div>
          {ending.type === "card" ? (
            <div className="space-y-1.5">
              <Label className="text-gray-300 text-xs">Short message</Label>
              <textarea data-testid="clip-card-message" value={ending.message} onChange={(e) => set({ message: e.target.value })} maxLength={280} rows={2} placeholder="Join us Sundays at 10am — everyone is welcome!"
                className="w-full rounded-lg bg-gray-950 border border-gray-800 px-3 py-2 text-sm text-white placeholder:text-gray-600 outline-none focus:border-amber-500/60 resize-none" />
              <p className="text-[11px] text-gray-500">Shows your church name, logo and website from Church Profile, plus this message.</p>
            </div>
          ) : (
            <div className="space-y-1.5">
              <Label className="text-gray-300 text-xs">Credit lines (one per line)</Label>
              <textarea data-testid="clip-credits-lines" value={ending.lines} onChange={(e) => set({ lines: e.target.value })} rows={4} placeholder={"Message — Pastor John Smith\nWorship — Grace Band\nSound — Mike Lee"}
                className="w-full rounded-lg bg-gray-950 border border-gray-800 px-3 py-2 text-sm text-white placeholder:text-gray-600 outline-none focus:border-amber-500/60 font-mono" />
              <p className="text-[11px] text-gray-500">Scrolls up, then ends with your church name, website and social links from Church Profile before fading out.</p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
